import {
    SHOW_LOADER,
    HIDE_LOADER,
    SET_LOADER_MESSAGE,
    SET_LOADER_VARIANT,
} from './constants';

const INIT_STATE = {
    isLoading: false,
    title: 'Loading...',
    subtitle: '',
    variant: 'inline', // Default variant - works with layout overlays
};

const Loading = (state = INIT_STATE, action) => {
    switch (action.type) {
        case SHOW_LOADER:
            return {
                ...state,
                isLoading: true,
                title: action.payload?.title || 'Loading...',
                subtitle: action.payload?.subtitle || '',
                variant: action.payload?.variant || 'inline',
            };
        case HIDE_LOADER:
            return {
                ...state,
                isLoading: false,
            };
        case SET_LOADER_MESSAGE:
            return {
                ...state,
                title: action.payload?.title || 'Loading...',
                subtitle: action.payload?.subtitle || '',
            };
        case SET_LOADER_VARIANT:
            return {
                ...state,
                variant: action.payload?.variant || 'inline',
            };
        default:
            return state;
    }
};

export default Loading;
